import React from 'react'
import moment from 'moment'
import _cx from 'classnames/bind'
import { Text, useApplicationContext, hooks } from '@adc/ui-adc'
import type { primitives } from '@adc/blueprint'
import PopupTooltip from '../../components/popupTooltip'
import IconPDF from '../../images/icon-pdf.svg'
import IconPDFGrey from '../../images/icon-pdf-grey.svg'
import { withModalHooks } from '../../hooks/useModalFeatures'
import cls from './index.scss'
const cx = _cx.bind(cls)

type DocumentFileComponentType = {
  label: string
  updatedDate?: string | number | Date | null
  disabled: boolean
  elmId: string
  viewSelectedDocument: () => void
  pushOnboardingQueueItem: (args: any[]) => void
  toggleAuthModal: (action: string, origin: string) => void
  disabledTooltip: JSX.Element
  onClick: () => void
}

const DocumentFileComponent = ({
  label,
  updatedDate,
  pushOnboardingQueueItem,
  toggleAuthModal,
  disabled = false,
  disabledTooltip,
  elmId = 'document',
  onClick,
  viewSelectedDocument,
}: DocumentFileComponentType) => {
  // Added date is formatted in the viewer's local timezone, so it must render
  // client-only — on the server the timezone is unknown, which would produce a
  // hydration text mismatch.
  const isMounted = hooks.useIsMounted()
  const { user: untypedUser } = useApplicationContext()
  const user = untypedUser as primitives.AuctionUser
  const promptLogin = () => {
    if (user.logged_in) {
      Promise.resolve(onClick && onClick()).then(viewSelectedDocument)
    } else {
      pushOnboardingQueueItem([promptLogin])
      toggleAuthModal('login', 'documents')
    }
  }

  return !disabled ? (
    <a
      className='u-display-f u-display-f-vcenter'
      onClick={promptLogin}
      target='_blank'
      rel='noopener noreferrer'
      data-elm-id={`${elmId}_doc`}
      title={label}
    >
      <div>
        <Text.Header level={2} as='span'>
          <img src={IconPDF} alt='pdf icon' className={cx('pdf-icon')} />
        </Text.Header>
      </div>
      <div>
        {label}
        {isMounted &&
          updatedDate !== undefined &&
          moment(updatedDate).isValid() && (
            <div className={cx('document-subtitle')}>
              Added: {moment(updatedDate).format('MMM DD, YYYY')}
            </div>
          )}
      </div>
    </a>
  ) : (
    <PopupTooltip
      content={disabledTooltip}
      position='top left'
      elmId='file_document'
      trigger={
        <a
          className={cx('u-display-f', 'u-display-f-vcenter', 'color-gray')}
          title={label}
        >
          <div>
            <Text.Header level={2} as='span'>
              <img
                src={IconPDFGrey}
                alt='pdf icon'
                className={cx('pdf-icon')}
              />
            </Text.Header>
          </div>
          <div>{label}</div>
        </a>
      }
    />
  )
}

export const DocumentFile = withModalHooks(DocumentFileComponent)
